'use strict';

document.addEventListener('DOMContentLoaded', () => {

	const accordionFunc = () => {
		const medicalAccordion = document.querySelector('.js-accordion');

		// コンテンツ内スライドトグル
		if(medicalAccordion !== null){
			// アコーディオンボタン
			const slideToggleBtn = document.querySelectorAll('.js-accordion__trigger');

			// アコーディオンイベント
			slideToggleBtn.forEach((target, index) => {
				target.addEventListener('click', (e) => {
					e.preventDefault();

					// 開閉
					const el = document.querySelectorAll('.js-accordion__container')[index];
					slideToggle(el, 300);

					// toggleClass
					const targetParent = target.parentNode;
					targetParent.classList.toggle('is__open');
				});
			})
		}
  }

	//初期リスト生成
	const createList = (response) => {
		var categoryName = response[0].category;
		var length = response.length;
		$("#js-listTitle").append('<h3 class="o-title__xl">' + categoryName + "一覧（" + length + "）</h3>");

		//繰り返し表示
		const contentArea = $("#js-jsonContents");
		var doneList = [];

		//field_sort_noでソート
		getJson.sort((a,b) => {
			var weightA = Number(a.weight);
			var weightB = Number(b.weight);
			if(weightA !== weightB){
				console.log(weightA,weightB);
				if (weightA < weightB) return -1;
				if (weightA > weightB) return 1;
			}

			var fsnoA = Number(a.field_sort_no);
			var fsnoB = Number(b.field_sort_no);
			if(fsnoA !== fsnoB){
				if (fsnoA < fsnoB) return -1;
				if (fsnoA > fsnoB) return 1;
			}
			return 0;
		});

		for(var index in getJson){
			//サブカテゴリーで絞り込み
			var subCategoryName = response[index].sub_category;

			//検索済みリストに入ってい流場合は何もしない
			if(doneList.length == 0 || doneList.indexOf(subCategoryName) == -1){
				//検索済みリストに設定
				doneList.push(subCategoryName);
			}else{
				continue;
			}

			var categoryJson = $.grep(getJson,function(res,i){return res.sub_category == subCategoryName});

			const html ='';
			html = '<section class="o-category__accordion__wrap js-accordion target-area">';
			html += '<h4 class="o-title__l js-accordion__trigger">' + subCategoryName + '（' + categoryJson.length + '）</h4><div class="o-category__accordion__box js-accordion__container"><ul class="o-category__list__wrap">';
			for(var obj of categoryJson){
				html += '<li class="o-category__list__box"><a href="' + obj.url + '">';
				if(obj.img){
					html += '<div class="o-category__list__img"><img src="' + obj.img + '"></div>';
				}
				html += '<div class="o-category__list__text">' +
								'<h5 class="o-text__m">' + obj.title + '<span class="f-icon__arrow"></span></h5>' +
								'<p class="o-text__s">' + obj.overview + '</p></div></a></li>';
			}
			html += '</ul></div></section>';
			contentArea.append(html);
		}
	}

	//tidが設定されてない場合はサンプルを呼び出す
	const jsonUrl = (!$('#tid').val() ? '/assets/js/json/sample_category.json' : '/json/prdsvc_list.json?field_prdsvc_category_target_id=' + $('#tid').val());
	var getJson = [];

	$.ajax({
		url: jsonUrl,
		get: 'get',
		dataType: 'json'
	}).done((response) => {
		// jsonの整形
		//グローバル変数に格納
		getJson = response;

		if(!response || response.length == 0){

		}else{
			createList(response);
			accordionFunc();
		}
	}).fail((error) => {
		console.log(error);
	});

	const searchWord = function(e){
		e.preventDefault();

		var searchText = $('.o-search__text').val(); // 検索ボックスに入力された値
		const titleArea = $("#js-listTitle");
		const contentArea = $("#js-jsonContents");
		//要素のリセット
		titleArea.empty();
		contentArea.empty();

		// 検索ボックスに値が入ってる場合
		if (searchText != '') {
				// 検索対象となるリストに入力された文字列が存在するかどうかを判断
				var resultJson = getJson.filter(function(item, index){
					searchText = searchText.replace(/　/g," ");//全角スペースは半角スペースに変換
					if ((item.title).indexOf(searchText) !== -1 || (item.overview).indexOf(searchText) !== -1) {
						return true;
					}
				});

				var categoryName = getJson[0].category;
				titleArea.append('<h3 class="o-title__xl">' + searchText + '（' + categoryName + '内）検索結果</h3>');

				if(!resultJson || resultJson.length == 0){
					titleArea.append('<p class="o-title__m">「 ' + searchText + '」に該当する結果はありませんでした。</p>');
				}else{
					titleArea.append('<p class="o-title__m">「 ' + searchText + '」の検索結果　' + resultJson.length + '件</p>');
					//繰り返し表示
					let html ='';
					html = '<ul class="o-card__wrap">';
					for(var i in resultJson){
						html += '<li class="o-card__link"><a href="' + resultJson[i].url + '">';
						if(resultJson[i].img){
							html += '<div class="o-card__img"><img src="' + resultJson[i].img + '" alt=""></div>';
						}
						html += '<div class="o-card__text"><h5 class="o-text__m">' + resultJson[i].title +'</h5><p class="o-caption">' + resultJson[i].overview + '</p></div>';
						html += '</li>';
					}
					contentArea.append(html);
				}
		}else{
			//検索ボックスが空の場合
			createList(getJson);
			accordionFunc();
		}
	};

	// searchWordの実行
	$('#js-searchButton').on('click', searchWord);

});